import { useRef } from "react";

const useRefEventListener = fn => {
	const fnRef = useRef(fn);
	fnRef.current = fn;
	return fnRef;
};

export default useRefEventListener;
